import { z } from 'zod';
import type { User } from '../auth/auth.js';

export const impersonateUserParamsSchema = z.object({
  user_id: z.uuid(),
});
export type ImpersonateUserParamsPayload = z.infer<typeof impersonateUserParamsSchema>;

export interface ImpersonateUserResponse {
  access_token: string;
  expires_in: number;
  user: User;
}
